import { apiClient } from '../api/ApiClient';
import { hideLoader, showLoader } from '../common/components/NavbarLoader/NavbarLoaderActions';
import { showAlert } from '../common/components/alert/AlertActions';
import AlertVariant from '../common/components/alert/AlertVariant';

function mapMarketingSelects(formData) {
  const mapped = { ...formData };
  [
    'phoneMarketingAllowed',
    'emailMarketingAllowed',
    'smsMarketingAllowed',
    'postMarketingAllowed',
  ].forEach((key) => {
    if (mapped[key] && typeof mapped[key] === 'object' && 'value' in mapped[key]) {
      mapped[key] = mapped[key].value;
    }
  });
  return mapped;
}

const AMEND_ENDPOINT = '/marketing-preferences/amend';
const REMOVE_ENDPOINT = '/marketing-preferences/remove';

export const amendMarketingPreferences = (formData) => async (dispatch) => {
  dispatch(showLoader());
  return apiClient
    .post(AMEND_ENDPOINT, mapMarketingSelects(formData))
    .then((res) => {
      if (res.status === 200) {
        dispatch(
          showAlert(
            'Thank you. We have received your request to update your data.',
            AlertVariant.SUCCESS,
          ),
        );
      }
      return res;
    })
    .catch((err) => {
      dispatch(showAlert('An error occurred while removing your data.', AlertVariant.DANGER));
      throw err;
    })
    .finally(() => dispatch(hideLoader()));
};

export const removeMarketingPreferences = (formData) => async (dispatch) => {
  dispatch(showLoader());
  return apiClient
    .post(REMOVE_ENDPOINT, mapMarketingSelects(formData))
    .then((res) => {
      if (res.status === 200) {
        dispatch(
          showAlert(
            'Thank you. We have received your request to remove your data.',
            AlertVariant.SUCCESS,
          ),
        );
      }
      return res;
    })
    .catch((err) => {
      dispatch(showAlert('An error occurred while removing your data.', AlertVariant.DANGER));
      throw err;
    })
    .finally(() => dispatch(hideLoader()));
};
